import React, { useState } from 'react';
import {
  Grid,
  Typography,
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  FormControl,
  FormHelperText,
  CircularProgress,
  Box,
  InputAdornment
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useMachineBinThresold } from 'hooks/useMachineHooks';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { gridSpacing } from 'store/constant';

export default function MachineBinThreshold({ machineDetails, setOpen }) {
  const [openThresold, setOpenThresold] = useState(false);
  const { mutate: updateBinThreshold, isPending: isLoadingBinThreshold } = useMachineBinThresold();

  const handleCloseThresold = () => setOpenThresold(false);

  return (
    <>
      <Grid container spacing={gridSpacing} style={{ paddingTop: '30px' }}>
        <Grid item xs={12}>
          <div style={{ border: '1px solid #6fd74b', borderRadius: '6px' }}>
            <div className="address_locationmain" style={{ background: '#6fd74b', mb: 2, padding: '10px 15px' }}>
              <Typography component="h4" variant="h3" sx={{ color: '#fff' }}>
                Machine Bin Threshold
              </Typography>
            </div>
            <Grid item xs={12} sm={12} md={12} lg={12} sx={{ padding: 0 }}>
              <div style={{ border: '1px solid #fff', marginLeft: 15, marginRight: 15, padding: 10 }}>
                <div
                  className="address_locationmain address_locationmain_new2"
                  style={{ padding: 5, display: 'flex', alignItems: 'center', gap: 10 }}
                >
                  <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                    Notify Recycler on :
                  </Typography>
                  <TextField
                    value={machineDetails?.binThreshold ?? 'N.A.'}
                    disabled
                    size="small"
                    InputProps={{ endAdornment: <span>%</span> }}
                  />
                  <Typography variant="h5" component="span" sx={{ fontWeight: 'unset' }}>
                    Bin Full
                  </Typography>
                </div>
                <DialogActions>
                  <Button disableElevation variant="contained" sx={{ color: '#fff' }} onClick={() => setOpenThresold(true)}>
                    Update
                  </Button>
                </DialogActions>
              </div>
            </Grid>
          </div>
        </Grid>
      </Grid>

      {openThresold && (
        <Dialog
          open={openThresold}
          fullWidth={true}
          fullScreen={false}
          onClose={handleCloseThresold}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          // maxWidth="sm"
        >
          <DialogTitle
            id="alert-dialog-title"
            variant="span"
            style={{
              textTransform: 'capitalize'
            }}
          >
            Machine Threshold Details
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleCloseThresold}
            sx={(theme) => ({
              position: 'absolute',
              right: 8,
              top: 8,
              color: theme.palette.grey[500]
            })}
          >
            <CloseIcon color="error" />
          </IconButton>

          <DialogContent dividers>
            <Formik
              initialValues={{
                binThreshold: ''
              }}
              // validationSchema={validationSchema}
              // validationSchema={Yup.object().shape({
              //   binThreshold: Yup.string()
              //     .trim()
              //     .required('Machine threshold cannot be empty')
              //     .matches(/^\d+$/, 'Only numeric values are allowed')
              // })}
              validationSchema={Yup.object().shape({
                binThreshold: Yup.string()
                  .trim()
                  .required('Machine threshold cannot be empty')
                  .matches(/^\d+$/, 'Only numeric values are allowed')
                  .test('max-value', 'Value cannot exceed 100', (value) => !value || Number(value) <= 100)
              })}
              onSubmit={(values) => {
                const submitData = {
                  binThreshold: values?.binThreshold || null,
                  id: machineDetails?.id
                };
                // console.log('🚀 ~ submitData:', submitData);
                updateBinThreshold(submitData, {
                  onSuccess: (res) => {
                    if (res?.status == 200) {
                      setOpenThresold(false);
                      setOpen(false);
                    } else {
                      setOpenThresold(false);
                      setOpen(false);
                    }
                  },
                  onError: (error) => {
                    console.log('error', error);
                    setOpenThresold(false);
                    setOpen(false);
                  }
                });
              }}
            >
              {({ errors, touched, handleChange, values, handleSubmit, handleBlur }) => (
                <>
                  <Form noValidate onSubmit={handleSubmit}>
                    <Grid
                      container
                      spacing={gridSpacing}
                      sx={{
                        alignContent: 'center'
                      }}
                    >
                      <Grid item xs={12}>
                        <Grid container spacing={gridSpacing}>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <FormControl
                              fullWidth
                              error={Boolean(touched.binThreshold && errors.binThreshold)}
                              //   sx={{ ...theme.typography.customInput }}
                            >
                              <TextField
                                variant="outlined"
                                type="text"
                                fullWidth
                                name="binThreshold"
                                value={values?.binThreshold}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={Boolean(touched.binThreshold && errors.binThreshold)}
                                InputProps={{
                                  endAdornment: <InputAdornment position="end">%</InputAdornment>
                                }}
                              />
                              {touched.binThreshold && errors.binThreshold && (
                                <FormHelperText
                                  error
                                  id="standard-weight-helper-text-email-login"
                                  sx={{
                                    fontSize: '13.8px'
                                  }}
                                >
                                  {errors.binThreshold}
                                </FormHelperText>
                              )}
                            </FormControl>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                    <DialogActions>
                      {errors.submit && (
                        <Box sx={{ mt: 3 }}>
                          <FormHelperText error>{errors.submit}</FormHelperText>
                        </Box>
                      )}
                      <Box sx={{ m: 1, position: 'relative' }}>
                        <Button
                          fullWidth
                          variant="contained"
                          type="submit"
                          style={{
                            color: '#fff'
                          }}
                          color="primary"
                          disabled={isLoadingBinThreshold}
                        >
                          Save
                          {isLoadingBinThreshold && (
                            <CircularProgress
                              size={24}
                              sx={{
                                color: '#16B1FF',
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                marginTop: '-12px',
                                marginLeft: '-12px'
                              }}
                            />
                          )}
                        </Button>
                      </Box>
                      <Button variant="outlined" type="reset" color="error" onClick={handleCloseThresold}>
                        Close
                      </Button>
                    </DialogActions>
                  </Form>
                </>
              )}
            </Formik>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}
